import { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination } from 'antd'
import AlumniDataRibbon from './ribbon'
import AlumniCertificationDetail from '../certification/detail'
import ImportAlumniData from './import'

export default function AlumniData() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [currentPage, setCurrentPage] = useState(1)
  const [propsData, setPropsData] = useState({})
  const [alumniData, setAlumniData] = useState({})
  const [isImportVisible, setIsImportVisible] = useState(false)
  const [isDetailVisible, setIsDetailVisible] = useState(false)

  const initialConditions = {
      status: 0
    }
    const [filterValue, setFilterValue] = useState(initialConditions)

  const getAlumniData = () => {
    axios.post('/p/alumni/list/get', { 
      merchant_oid: merchantOid,
      source: 1,
      status: filterValue.status,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAlumniData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'alumni_users': response.data.alumni_users
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAlumniData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, currentPage, filterValue])

  const getColor = (key) => {
    if (key === 2) return 'green'
    return 'black'
  }

  const previewDetail = (oid) => {
    setIsDetailVisible(true)
    setPropsData({ oid: oid})
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">校友数据</div>
          <AlumniDataRibbon 
            isImportVisible={() => { setIsImportVisible(true) }}
            filterValue={filterValue} 
            setFilterValue={setFilterValue}
          />
        </div>

        <div className='public-main-style2'>
          <table className='public-main-style2-item'>
            <thead>
              <tr className='public-main-style2-thead'>
                <th style={{textAlign: 'left', paddingLeft: '20px'}}>姓名</th>
                <th>身份证号</th>
                <th>手机号</th>
                <th>认领状态</th>
                <th>认领时间</th>
              </tr>
            </thead>

            <tbody>
              {alumniData.alumni_users && (alumniData.alumni_users.length > 0 ? (alumniData.alumni_users.map((item) => (
                <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { previewDetail(item.oid) }}>
                  {item.photo_url ?  
                    <td style={{textAlign: 'left', padding: '5px 0 5px 20px', display: 'flex', alignItems: 'center'}}>
                      <img style={{height: '50px', marginRight: '10px'}} src={item.photo_url} alt="" />
                      {item.name}
                    </td> : <td style={{textAlign: 'left', paddingLeft: '20px'}}>{item.name}</td>
                  }
                  <td>{item.id_number}</td>
                  <td>{item.phone}</td>
                  <td style={{ color: getColor(item.status.key) }}>{item.status.value}</td>
                  <td>{item.claim_time || '-'}</td>
                </tr>
              ))) : (
                <tr className='public-main-style2-tbodyEmpty'>
                  <td colSpan="5"><span>暂无数据</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='pagination'>
          <Pagination 
            current={currentPage}
            total={alumniData.total}
            pageSize={20}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total) => `共${total}条`}
            showSizeChanger={false}
            hideOnSinglePage={true}
            showQuickJumper={true}
          />
        </div>

        {isDetailVisible && <AlumniCertificationDetail
          data={propsData}
          isOpen={isDetailVisible}
          getAlumniData={getAlumniData}
          isCancel={() => { setIsDetailVisible(false) }}
          showAudit={false}
        />}

        {isImportVisible && <ImportAlumniData
          filterValue={filterValue} 
          getAlumniData={getAlumniData}
          isOpen={isImportVisible}
          isCancel={() => { setIsImportVisible(false) }}
        />}
      </div>
    </div>
  )
}
